export default {
    // 主面板
    back: '返回',
    dd: '天',
    hh: '时',
    mm: '分',
    ss: '秒',
    send: '发送',
    detail: '详情', // 详情
    discuss: '讨论', // 讨论
    content: '目录',
    duration: '时长',
    backPlay: '回放',
    cloudHall: '展厅',
    enterprise: '企业鸣谢',
    conven: '分会场',
    awardQA: '有奖竞答',
    discussLoginTip: '您当前的身份不能参与发言。', // 发言登录提示
    drawLoginTip: '请登录后再参与抽奖。', // 抽奖登录提示
    feedbackLoginTip: '请登录后再进行意见反馈。', // 意见反馈登录提示
    complainLoginTip: '请登录后再进行投诉。', // 投诉登录提示
    mineLoginTip: '请登录后再查看我的资料。', // 我的资料登录提示
    toLogin: '登录',
    loginIn: '登 录',
    guest: '游客',
    countdown: '直播倒计时',
    widthMobile: '手机',
    scanWx: '请使用微信扫码',
    // 登录框
    loginMobileTitle: '登 录',
    loginEmailTitle: '登 录',
    loginPhoneLabel: '手机号',

    loginPhoneTip: '请输入手机号',
    loginVerificationLabel: '验证码',
    loginVerificationLabelPassword: '密码',
    loginVerificationTip: '请输入验证码',
    loginVerificationTipPassword: '请输入密码（原始密码：111111）',
    loginNameLabel: '姓名',
    loginNameTip: '请输入姓名',
    loginCompanyLabel: '所在医院全称',
    loginCompanyTip: '请输入所在医院全称',
    loginOfficeLabel: '所在科室',
    loginOfficeTip: '请输入所在科室',
    loginInGuest: '游客身份观看',
    loginGetCode: '获取验证码',
    areaCode: '区号',
    loginTitlePassword: '密码登录',
    loginTitleTel: '验证码登录',
    // 手机绑定弹框
    bindMobileTitle: '手机号绑定',
    bindLoginIn: '绑 定',
    bindSuccess: '绑定成功',
    bindFail: '绑定失败',
    // 邮箱登录框
    loginEmailLabel: '邮箱',
    loginEmailTip: '请输入邮箱',
    correctEmialTip: '请输入正确的邮箱和验证码',
    correctLoginTip: '请输入正确的手机号和验证码',
    correctLoginTipPassword: '请输入正确的手机号',
    correctLoginTipTel: '请输入正确的手机号',
    correctLoginTipTelPassword:'请输入密码',
    // 广告
    skip: '跳过',
    // 抽奖
    startCountdown: '开始倒计时',
    endCountdown: '结束倒计时',
    last: '剩余',
    lastDrawNums: '次抽奖机会',
    seeMyGift: '查看我的奖品',
    drawRule: '抽奖规则',
    thx: '谢谢参与',
    notstart: '未开始',
    drawNow: '立即抽奖',
    drawOver: '次数用完',
    hasEnd: '已结束',
    drawnotstart: '抽奖未开始',
    drawing: '进行中',
    drawend: '抽奖已结束',
    gift: '奖品',
    drawLessNum: '抽奖次数已用完',
    draw: '抽奖',
    drawNoPerfect: '没有完善资料',
    drawGoPerfect: '尽快去完善',
    drawResult: '抽奖结果',
    drawFailTip: '很遗憾，大奖与您擦肩而过',
    congratulations: '恭喜您获得',
    perfectAddress: '完善收货信息',
    agreementTip: '我同意将以上填写的个人信息提供给活动主办方',
    emailTip: '奖品发货信息将发送到您的邮箱',
    submited: '已提交',
    name: '姓名',
    tel: '电话',
    telTip: '请输入电话',
    email: '邮箱',
    emailResTip: '请输入邮箱',
    address: '地址',
    addressTip: '请输入地址',
    // 时长
    currentAccount: '当前登录账号',
    noLogin: '未登录',
    noReportDuration: '未上报时长',
    reportDuration: '上报',
    totalDuration: '累计观看时长',
    RequiredViewingTime: '要求观看时长',
    RequiredViewingTimeLIVE: '要求观看直播时长',
    RequiredViewingTimeVOD: '要求观看点播时长',
    RequiredViewingTimeALL: '要求观看直播加点播时长',
    Minutes: '分钟',
    // enterStatus: '学分报名状态',
    enterStatus: '报名状态',
    applyInfo: '报名信息',
    enterYes: '已报名',
    enterNo: '未报名',
    // 姓名医院登录
    hasRead: '已阅读并同意遵守',
    policy: '隐私协议',
    needCheckPolicy: '请勾选该协议',
    // 完善资料弹窗
    perfect: '完善资料',
    perfectOfficesLabel: '所在科室',
    perfectOfficesTip: '请输入所在科室',
    perfectJobLabel: '职称',
    perfectJobTip: '请输入职称',
    submit: '提 交',
    selectTypeLabel: '身份',
    selectType: '点击选择身份',
    selectHospitalLabel: '所在医院',
    selectHospital: '请选择所在医院',
    selectOfficeLabel: '所在科室',
    selectOffice: '请选择所在科室',
    selectJobTitleLabel: '职称',
    selectJobTitle: '请选择职称',
    selectSchoolLabel: '学校',
    selectSchool: '请选择学校',
    selectSpecialtyLabel: '专业',
    selectSpecialty: '请输入专业',
    selectEducationLabel: '学历',
    selectEducation: '请选择学历',
    selectUnitLabel: '单位',
    selectUnit: '请输入单位',
    selectPostLabel: '职务',
    selectPost: '请输入职务',
    selectSexLabel: '性别',
    selectSex: '请选择性别',
    selectBirthdayLabel: '生日',
    selectBirthday: '请选择生日',
    selectKeyword: '请输入搜索关键词',
    perfectTip: '注：请确认以上填写为本人真实有效信息',
    besure: '确定',
    becancel: '取消',
    // 隐私条款
    sure: '确 定',
    // 投诉反馈
    more: '更多',
    consult: '咨询客服',
    mineTitle: '我的资料',
    complain: '投诉',
    complainReason: '请选择投诉原因',
    complainContent: '内容',
    complainContentPlaceholder: '请详细描述您遇到的问题，并上传相关页面的截图',
    complainDescPlaceholder: '请填写问题内容',
    complainImages: '截图',
    complainImagesPlaceholder: '请上传至少一张截图',
    submitQuick: '立即提交',
    feedback: '意见反馈',
    feedbackTitle: '标题',
    feedbackTitlePlaceholder: '请输入标题',
    feedbackContent: '详细描述',
    feedbackContentDesc: '请填写详细描述',
    feedbackContentPlaceholder: '请详细描述您遇到的问题，并上传相关页面的截图，使得我们为您提供更好的帮助',
    feedbackImages: '上传图片',
    feedbackSubmit: '提交反馈',
    feedbackFail: '游客模式不允许投诉',
    // 我的资料
    mineInfo: '我的资料',
    shipAddressLabel: '收货地址',
    shipAddressTip: '请输入完整收货地址',
    mineSave: '保存',
    mineLogout: '退出登录',
    mineLogoutTip: '确认退出登录？',
    // 多会场
    hasNoLink: '您没有该直播观看权限，请联系会务组',
    // 无权限提示
    noauthTip: '提 示',
    logoutDesc: '确认要退出登录？',
    noauthDesc: '很抱歉，您没有直播观看权限，请联系工作人员或重新登录',
    noauthBtn: '重新登录',
    // 其他
    verificationSuccess: '验证码发送成功',
    verificationFail: '验证码发送失败',
    verificationTypeError : '类型错误',
    verificationFrequently: '验证发送过于频繁、请两分钟之后再试',

    loginSuccess: '登录成功',
    loginFail: '登录失败',
    hospitalLoginValidFail: '姓名和医院不能为空或空格',
    saveSuccess: '保存成功',
    saveFail: '保存失败',
    perfectSuccess: '完善成功',
    perfectFail: '完善资料失败',
    authFail: '获取直播观看权限失败，请稍后再试',
    appointFail: '预约失败',
    noLiveTip: '当前会议无任何直播或回放，请联系后台管理员设置',
    submitSuccess: '提交成功',
    // 有奖竞答
    activityRule: '活动规则',
    winnersList: '中奖名单',
    participantsList: '参与名单',
}
